import {
  calculateArriveTimeByVolume,
  calculateVolumeByArriveTime,
  getCanChoosePeriod
} from '@/cllib/pi'

import {
  gasPiOrderUpdateData,
  gasPiOrderOutPut2,
  gasPiOrderOutPut
} from '@/api/api'

import {
  dateOperating
} from '@/cllib/tools'

import {
  verifyDataFloat
} from '@/cllib/verify'

let dcopy = require('deep-copy')

const state = {
  piGasOrderOne: {
    arriveTime: null,
    volume: '',
    orderIndex: -1,
    depotId: -1,
    remark: ''
  },
  newPiGasOrderOne: {
    arriveTime: null,
    volume: ''
  }
}

const getters = {
  piGasOrderOne: state => state.piGasOrderOne,
  newPiGasOrderOne: state => state.newPiGasOrderOne
}

const actions = {
  setPiGasOrderOneArriveTime ({ commit, dispatch, getters }, data) {
    commit('setPiGasOrderOneArriveTime', data)
    let order = {volume: getters.piGasOrderOne.volume, arriveTime: getters.piGasOrderOne.arriveTime, depotId: getters.piGasOrderOne.depotId, remark: getters.piGasOrderOne.remark}
    dispatch('updatePiGasPiOrder', {action: 'update', order, orderIndex: getters.piGasOrderOne.orderIndex})
  },
  setPiGasOrderOneVolume ({ commit, dispatch, getters }, data) {
    if (verifyDataFloat(data) === 'pass' && Number(data) > 0) {
      commit('setPiGasOrderOneVolume', Number(data))
      let order = {volume: getters.piGasOrderOne.volume, arriveTime: getters.piGasOrderOne.arriveTime, depotId: getters.piGasOrderOne.depotId, remark: getters.piGasOrderOne.remark}
      dispatch('updatePiGasPiOrder', {action: 'update', order, orderIndex: getters.piGasOrderOne.orderIndex})
    } else {
      if (![0, '0', ''].includes(getters.piGasOrderOne.volume)) {
        dispatch('showNoticeMsg', {type: 'error', title: '输入错误', message: '请输入有效数字'})
      }
      commit('setPiGasOrderOneVolume', 0)
    }
  },
  setPiGasOrderOneDepotId ({ commit, dispatch, getters }, data) {
    commit('setPiGasOrderOneDepotId', data)
    let order = {volume: getters.piGasOrderOne.volume, arriveTime: getters.piGasOrderOne.arriveTime, depotId: getters.piGasOrderOne.depotId, remark: getters.piGasOrderOne.remark}
    dispatch('updatePiGasPiOrder', {action: 'update', order, orderIndex: getters.piGasOrderOne.orderIndex})
  },
  setPiGasOrderOneRemark ({ commit, dispatch, getters }, data) {
    commit('setPiGasOrderOneRemark', data)
    let order = {volume: getters.piGasOrderOne.volume, arriveTime: getters.piGasOrderOne.arriveTime, depotId: getters.piGasOrderOne.depotId, remark: getters.piGasOrderOne.remark}
    dispatch('updatePiGasPiOrder', {action: 'update', order, orderIndex: getters.piGasOrderOne.orderIndex})
  },
  setNewPiGasOrderOneArriveTime ({ commit, dispatch, getters }, data) {
    let volume = calculateVolumeByArriveTime(getters.piHourStatus, data)
    dispatch('updatePiGasPiOrder', {action: 'add', order: {volume, arriveTime: data}})
    dispatch('initNewPiGasOrderOne')
  },
  setNewPiGasOrderOneVolume ({ commit, dispatch, getters }, data) {
    commit('setNewPiGasOrderOneVolume', data)
  },
  gasPiOrderOutPut ({ getters }) {
    let parm = {
      sendTime: getters.piDateStr
    }
    return gasPiOrderOutPut(parm)
  },
  gasPiOrderOutPut2 ({ getters }) {
    let parm = {
      sendTime: getters.piDateStr
    }
    return gasPiOrderOutPut2(parm)
  },
  inputNewPiGasOrderOneVolumeOver ({ commit, getters, dispatch }) {
    if (verifyDataFloat(getters.newPiGasOrderOne.volume) === 'pass' && Number(getters.newPiGasOrderOne.volume) > 0) {
      let volume = Number(getters.newPiGasOrderOne.volume)
      let piGasPiOrder = dcopy(getters.piGasPiOrder)
      let canChoosePeriod = getCanChoosePeriod(getters.piCanPeratePeriod, piGasPiOrder, piGasPiOrder.length)
      let arriveTime = canChoosePeriod.canChooseStartTime && canChoosePeriod.canChooseEndTime ? (calculateArriveTimeByVolume(getters.piHourStatus, canChoosePeriod, volume) || dateOperating.computeDay({days: 1, date: new Date()})) : dateOperating.computeDay({days: 1, date: new Date()})
      dispatch('updatePiGasPiOrder', {action: 'add', order: {arriveTime: dateOperating.formatDate({date: arriveTime, format: 'yy-mm-dd hh:mm'}), volume}})
      dispatch('initNewPiGasOrderOne')
    } else {
      if (![0, '0', ''].includes(getters.newPiGasOrderOne.volume)) {
        dispatch('showNoticeMsg', {type: 'error', title: '输入错误', message: '请输入有效数字'})
      }
      dispatch('setNewPiGasOrderOneVolume', '')
    }
  },
  initNewPiGasOrderOne ({ commit }) {
    commit('setNewPiGasOrderOne', {
      arriveTime: null,
      volume: ''
    })
  },
  setPiGasOrderOne ({ commit }, data) {
    commit('setPiGasOrderOne', data)
  },
  updatePiGasPiOrder ({ commit, getters, dispatch }, {action, order, orderIndex}) {
    let piGasPiOrder = dcopy(getters.piGasPiOrder)
    if (action === 'add') {
      order.depotId = getters.piChooseGasOrder.depotId
      piGasPiOrder.push(order)
    } else if (action === 'update') {
      piGasPiOrder[orderIndex] = order
    } else if (action === 'del') {
      let newPiGasPiOrder = []
      piGasPiOrder.forEach((item, index) => {
        if (index !== orderIndex) {
          newPiGasPiOrder.push(item)
        }
      })
      piGasPiOrder = newPiGasPiOrder
    }
    dispatch('setPiGasPiOrder', piGasPiOrder)
    if (getters.piChooseGasOrder && getters.piChooseGasOrder.id) {
      let volumeTotal = 0
      let newOrders = []
      piGasPiOrder.forEach((item) => {
        newOrders.push({
          volume: item.volume,
          arriveTime: dateOperating.formatDate({date: item.arriveTime, format: 'yy-mm-dd hh:mm:ss'}),
          sendTime: getters.piChooseGasOrder.sendTime,
          gasId: getters.piChooseGasOrder.gasId,
          gasTankId: getters.piChooseGasOrder.gasTankId,
          depotId: item.depotId,
          remark: item.remark,
          order_id: getters.piChooseGasOrder.id
        })
        volumeTotal += item.volume
      })
      gasPiOrderUpdateData(getters.piChooseGasOrder.id, newOrders)
      dispatch('updateOverRate', {id: getters.piChooseGasOrder.id, volume: volumeTotal})
    }
  }
}

const mutations = {
  setPiGasOrderOneDepotId (state, data) {
    state.piGasOrderOne.depotId = data
  },
  setPiGasOrderOneRemark (state, data) {
    state.piGasOrderOne.remark = data
  },
  setPiGasOrderOneArriveTime (state, data) {
    state.piGasOrderOne.arriveTime = data
  },
  setPiGasOrderOneVolume (state, data) {
    state.piGasOrderOne.volume = data
  },
  setPiGasOrderOne (state, data) {
    state.piGasOrderOne = data
  },
  setNewPiGasOrderOneArriveTime (state, data) {
    state.newPiGasOrderOne.arriveTime = data
  },
  setNewPiGasOrderOneVolume (state, data) {
    state.newPiGasOrderOne.volume = data
  },
  setNewPiGasOrderOne (state, data) {
    state.newPiGasOrderOne = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pi/pi_gas_pi_order.js